<template>
	<div class="contact-details">
		<tw-title description="Please enter the contact details of the purchaser"
			:email="(quote && quote.client) ? true : false">Contact details</tw-title>

		<div class="relative" :class="{ 'h-64': loading }">
			<div class="contact-details-container" v-if="!loading && quote">

				<div class="w-full md:max-w-xl mx-auto error mb-5" v-if="contactFeedback">
					<div class="bg-red-50 border-l-4 border-red-400 p-4 rounded-r-md">
						<div class="flex">
							<div class="flex-shrink-0">
								<svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
									<path fill-rule="evenodd"
										d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
										clip-rule="evenodd" />
								</svg>
							</div>
							<div class="ml-3">
								<p class="text-sm leading-5 text-red-700" v-for="feedback in contactFeedback">
									{{ feedback }}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div v-if="!client" class="mb-10">
					<div class="max-w-xl mx-auto">

						<register-form v-if="type == 'form'"></register-form>

						<div class="relative mt-10">
							<div class="absolute inset-0 flex items-center" aria-hidden="true">
								<div class="w-full border-t border-gray-300"></div>
							</div>
							<div class="relative flex justify-center">
								<span class="px-2 bg-white text-sm text-gray-500">
									Or
								</span>
							</div>
						</div>


						<social-login :type="type" @change-type="handleChangeType"></social-login>
					</div>
				</div>

				<div class="contact-row" v-else>
					<div class="input-container" :class="{ 'required-error': !form.contact.first_name }">
						<h3>First name</h3>
						<input type="text" class="form-input mt-2" v-model="form.contact.first_name"
							placeholder="First name">
					</div>

					<div class="input-container" :class="{ 'required-error': !form.contact.surname }">
						<h3>Surname</h3>
						<input type="text" class="form-input mt-2" v-model="form.contact.surname" placeholder="Surname">
					</div>
					<div class="input-container">
						<h3>Phone number <span
								class="hidden items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">Required</span>
						</h3>
						<input type="text" class="form-input mt-2" v-model="form.contact.phone_number"
							placeholder="Phone number">
					</div>
					<div class="input-container email-container">
						<tw-alert :type="(email.success) ? 'success' : 'error'" :show="email.feedback !== false"
							:fadeable="true" class="mb-3" @close="email.feedback = false">
							{{ email.feedback }}
						</tw-alert>

						<h3>Email Address <span class="text-xs text-teal-500 underline cursor-pointer"
								v-tw-modal:edit-email>Wrong Email?</span></h3>
						<div class="grid grid-cols-1 input-container disabled">
							<input type="text" class="form-input mt-2" readonly v-model="form.contact.email"
								placeholder="Email address">
						</div>
					</div>
					<div class="input-container">
						<h3>
						Date of Birth
						<button class="tooltip-el"
								v-tooltip="'You must be aged 18 or over at the time of purchasing this insurance and if you want to cover any family members (as defined under the policy) they must be aged 16 or over and reside at the same address.'">?</button>
						<span class="
							hidden
							items-center
							px-2.5
							py-0.5
							rounded-full
							text-xs
							font-medium
							bg-red-100
							text-red-800
							">Required </span>
						</h3>
						<div class="mt-2">
							<input type="date" name="date_of_birth" :max="dates.max" v-model="form.contact.dob" autocomplete="off" />
						</div>
					</div>
				</div>

				<div v-if='client'>
					<div class="pb-2 border-b border-gray-200 mt-12 mb-5">
						<div class="text-2xl font-bold text-gray-700">
							Address
						</div>
						<p class="text-gray-500 font-light">
							This must be the address where your bikes are stored
						</p>
					</div>

					<div class="contact-row">
						<div class="input-container postcode-container">
							<h3>Find by postcode</h3>

							<input type="text" class="form-input" v-model="postcodeSearch" placeholder="Postcode">
						</div>
						<div class="input-container">
							<br>
							<tw-button height="h-10" :disabled="(addressLoading) ? true : false" @clicked="getAddress">{{
								(addressLoading) ? 'Searching...' : 'Search' }}</tw-button>
						</div>
					</div>

					<div class="address-suggestions contact-row">
						<div class="col-span-12 md:col-span-12 mt-2" v-if="showSuggestions">
							<tw-select title="" :items="addressSuggestions" additional-class="quote-input-select"
								@updated="addressSelected"></tw-select>
						</div>
					</div>

					<div class="relative my-6">
						<div class="absolute inset-0 flex items-center">
							<div class="w-full border-t border-gray-200"></div>
						</div>
						<div class="relative flex justify-center text-sm leading-5">
							<span class="px-2 bg-white font-light text-gray-500">
								Or enter manually
							</span>
						</div>
					</div>

					<div class="error mb-5" v-if="addressFeedback">
						<div class="bg-red-50 border-l-4 border-red-400 p-4">
							<div class="flex">
								<div class="flex-shrink-0">
									<svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
										<path fill-rule="evenodd"
											d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
											clip-rule="evenodd" />
									</svg>
								</div>
								<div class="ml-3">
									<p class="text-sm leading-5 text-red-700" v-for="feedback in addressFeedback">
										{{ feedback }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<div class="space-y-2">
						<div class="contact-row">
							<div class="input-container">
								<h3>House Number/Name</h3>
								<input type="text" class="form-input mt-2" v-model="form.address.house"
									placeholder="House number">
							</div>
						</div>
						<div class="contact-row">

							<div class="input-container">
								<h3>Street</h3>
								<input type="text" class="form-input mt-2" v-model="form.address.street"
									placeholder="Street">
							</div>
						</div>
						<div class="contact-row">
							<div class="input-container">
								<h3>Town/City</h3>
								<input type="text" class="form-input mt-2" v-model="form.address.town"
									placeholder="Town/City">
							</div>
						</div>

						<div class="contact-row">
							<div class="input-container">
								<h3>County</h3>
								<input type="text" class="form-input mt-2" v-model="form.address.county"
									placeholder="County">
							</div>
						</div>
						<div class="contact-row">

							<div class="input-container">
								<h3>Postcode</h3>
								<input type="text" class="form-input mt-2" v-model="form.address.postcode"
									placeholder="Postcode">
							</div>
						</div>
					</div>

					<div class="where mb-10">
						<div class="text-2xl font-bold text-gray-700 mb-4 mt-14">Where did you hear about us?</div>
						<div class="where-container">
							<tw-select :val="hearFromUs" :items="allHearFromUs"
								@updated="hearFromUsUpdated"></tw-select>
						</div>

						<p class="pt-5 pb-4 text-gray-700 font-light">At Protectmybike, we would like to keep you up to date
							with products and offers that we think you might like to hear about. If we do, we will only ever
							contact you by email. We will not sell or pass any personal information to any third parties for
							their marketing purposes. If you would like to know more about how we protect your data, please
							read our <a class="cursor-pointer" v-tw-modal:privacy-modal>privacy policy</a>.</p>

						<p class="pb-6">Please let us know if you would like us to contact you or not by selecting one of
							the options below:</p>

						<div class="offers-container">
							<tw-toggle-group name="offers" :options="offersOptions" @updated="offersUpdated"
								:selected="selectedOffer"
								class="grid grid-cols-1 sm:grid-cols-2 gap-4 radio"></tw-toggle-group>
						</div>
					</div>
				</div>
			</div>
			<loading :show="loading"></loading>
		</div>

		<tw-modal ref="privacy-modal" size="xl2" :padding="false" :show-ok="false" cancel-text="Close">
			<template v-slot:header>Privacy Policy</template>
			<template v-slot:body>
				<div class="privacy-container" v-html="$parent.setting.privacy"></div>
			</template>
		</tw-modal>

		<tw-modal ref="edit-email" :padding="false" @ok="updateEmail">
			<template v-slot:header>Update Email Address</template>
			<template v-slot:body>
				<input type="text" class="form-input mt-2 w-full" v-model="form.contact.email" placeholder="Email address">
			</template>
		</tw-modal>
	</div>
</template>

<script>
import RegisterForm from './auth/RegisterForm'
import SocialLogin from './auth/Social'
export default {
	name: 'form.contact_details',
	props: {
		loading: {},
		quote: {},
	},
	components: {
		RegisterForm,
		SocialLogin,
	},
	data() {
		return {
			type: 'form',
			form: {
				contact: {
					first_name: '',
					surname: '',
					email: '',
					phone_number: '',
					hear_from_us: '',
					offers: '',
					dob: '',
				},
				address: {
					house: '',
					street: '',
					town: '',
					county: '',
					postcode: '',
				},
			},
			postcodeSearch: null,
			addresses: null,
			showSuggestions: false,
			addressLoading: false,
			contactFeedback: false,
			addressFeedback: false,
			hear_from_us: false,
			email: {
				loading: false,
				success: false,
				feedback: false
			},
			client: false,
		}
	},
	computed: {
		dates() {
			let max = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
			return {
				max: max.toISOString().substring(0, 10),
			}
		},
		addressSuggestions() {
			let addr = [];

			if (this.addresses) {
				this.addresses.addresses.forEach((a, i) => {
					addr.push({
						id: i,
						name: a.formatted_address.join(', '),
						data: a
					});
				})
			}

			return addr;
		},
		allHearFromUs() {
			let hearFromUsArr = [];

			if (this.$parent.details.hearFromUs) {
				this.$parent.details.hearFromUs.forEach((r) => {
					hearFromUsArr.push({
						id: r + "_id",
						name: r,
						value: r
					})
				})
			}

			return hearFromUsArr;
		},
		hearFromUs() {
			let hear = false;

			if (this.form.contact.hear_from_us) {
				hear = {
					id: this.form.contact.hear_from_us + '_id',
					name: this.form.contact.hear_from_us,
					value: this.form.contact.hear_from_us,
				}
			}

			return hear;
		},
		selectedOffer() {
			let offer = '';

			if (this.form.contact.offers && this.form.contact.offers != '') {
				let currOffer = this.form.contact.offers;
				offer = this.offersOptions.filter((o) => o.value == currOffer);

				if (offer[0]) {
					offer = offer[0].name;
				}
			}

			return offer;
		},
		offersOptions() {
			return [
				{
					name: "Yes please, I'd like to receive offers by email",
					value: 'true',
				},
				{
					name: "No thanks, I don't want to receive any offers",
					value: 'false',
				}
			]
		},
		isComplete() {
			let allowed = true;

			let notAllowed = ['', ' '];
			// contact details validation
			if (notAllowed.includes(this.form.contact.first_name)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.contact.surname)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.contact.email)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.contact.offers)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.contact.dob)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.address.town)) {
				allowed = false;
			}
			if (notAllowed.includes(this.form.address.postcode)) {
				allowed = false;
			}


			return allowed;
		}
	},
	watch: {
		quote: function (val, oldVal) {
			this.populateForm();
		},
		form: {
			handler: function (val, oldVal) {
				this.$emit('refresh', { passed: this.isComplete });
			},
			deep: true
		}
	},
	mounted() {
		this.load();
	},
	methods: {
		load() {
			this.populateForm();
		},
		populateForm() {
			// get hear from us options
			const self = this;

			if (this.quote) {

				this.client = this.quote.client;

				if (this.client) {

					let name = false;
					let first_name = '';
					let last_name = '';
					if (this.client.name) {
						name = this.client.name.split(" ");

						var name_length = name.length;

						name.forEach((n, i) => {
							if (name_length == 1) {
								first_name += n;
							}
							else if ((i + 1) != name_length) {
								if (first_name != '') {
									first_name += ' ';
								}
								first_name += n;
							} else {
								if (last_name != '') {
									last_name += ' ';
								}
								last_name += n;
							}
						});


					}

					// contact details
					this.form.contact.first_name = first_name;
					this.form.contact.surname = last_name;
					this.form.contact.phone_number = this.client.phone;
					this.form.contact.email = this.client.email;
					this.form.contact.hear_from_us = this.client.hear_from_us;
					this.form.contact.offers = this.client.offers == 1 ? 'true' : 'false';
					this.form.contact.dob = this.client.dob;

				} else {

				}

				this.$emit('hide-footer', this.client == null);

				if (this.quote.address) {
					// address details
					this.form.address.house = this.quote.address.house;
					this.form.address.street = this.quote.address.street;
					this.form.address.town = this.quote.address.town;
					this.form.address.county = this.quote.address.county;
					this.form.address.postcode = this.quote.address.postcode;

					// prepopulate postcode search
					this.postcodeSearch = this.form.address.postcode
				}

				if (this.quote.hearFromUs) {
					this.form.contact.hear_from_us = this.quote.hearFromUs;
				}
			}
		},
		submit() {
			const self = this;

			// start loading gif
			self.$emit('loading', true);

			// clear errors
			self.contactFeedback = false;
			self.addressFeedback = false;

			let clientObj = Object.assign(this.form.contact, this.form.address);

			axios.post('quote/client/update', clientObj)
				.then((resp) => {
					if (resp.data) {
						self.$emit('loading', false);

						if (resp.data.success) {
							// refresh step
							self.$emit('refresh', { quote: resp.data.quote });

							// go to next step
							self.$emit('next', true);
						} else {
							let feedback = resp.data.feedback;
							let errors = [];
							Object.keys(feedback.errors).forEach((k) => {
								errors.push(feedback.errors[k][0]);
							})
							self.contactFeedback = errors;

							// stop loading gif
							self.$emit('loading', false);
						}
					}
				})
				.catch((error) => {
					let feedback = error.response.data;
					let errors = [];
					Object.keys(feedback.errors).forEach((k) => {
						errors.push(feedback.errors[k][0]);
					})
					self.contactFeedback = errors;

					// stop loading gif
					self.$emit('loading', false);
				});
		},
		getAddress() {
			const self = this;

			self.addressLoading = true;

			if (this.postcodeSearch && this.postcodeSearch !== '') {
				axios.get('quote/addressLookup/' + this.postcodeSearch)
					.then((resp) => {
						self.addressLoading = false;

						if (resp.data.success) {
							self.addresses = resp.data.response;
							self.showSuggestions = true;
						} else {
							// push to parent component to display feedback
							self.$emit('feedback', {
								'type': 'error',
								'message': resp.data.response
							});
						}
					})
					.catch(error => {
						self.addressLoading = false;

						// push to parent component to display feedback
						self.$emit('feedback', {
							'type': 'error',
							'message': error
						});
					});
			}
		},
		addressSelected(e) {
			let suggestion = this.addressSuggestions[e.id];

			// override address
			this.form.address.house = suggestion.data.building_number;

			// defaults for street (address layout varies)
			var street = suggestion.data.line_3;
			if (street == '') {
				street = suggestion.data.line_2;
			}
			if (street == '') {
				street = suggestion.data.thoroughfare;
			}
			this.form.address.street = street;

			this.form.address.town = suggestion.data.town_or_city;
			this.form.address.county = suggestion.data.county;
			this.form.address.postcode = this.postcodeSearch;

			// refresh data on parent
			this.$emit('refresh', { passed: this.isComplete });
		},
		hearFromUsUpdated(e) {
			this.form.contact.hear_from_us = e.value;
		},
		offersUpdated(e) {
			this.form.contact.offers = e.value;

			this.$emit('refresh', { passed: this.isComplete });
		},
		clientSuggestionUpdated(e) {
			this.clientSuggestion = e;
			this.form.contact.first_name = e.first_name;
			this.form.contact.surname = e.surname;
		},
		updateEmail() {
			const self = this;

			self.email.loading = true;

			axios.patch('quote/client/email/' + this.quote.quote_id, { email: this.form.contact.email })
				.then((resp) => {
					self.email.loading = false;

					if (resp.data.success) {
						self.email.success = true;
						self.email.feedback = resp.data.feedback;
					} else {
						self.email.success = false;
						self.email.feedback = resp.data.feedback.errors.email[0];
					}
				})
				.catch(error => {
					self.email.loading = false;

					self.email.success = false;
					self.email.feedback = 'An error occurred. Please try again';
				});
		},
		getQuote(e) {
			const self = this;

			if (this.quote.quote_id) {
				axios.get('quote/getQuote')
					.then((resp) => {
						if (resp.data) {
							if (resp.data.quote && resp.data.quote.client) {
								self.client = resp.data.quote.client;

								if (e.popup.closed) {
									clearInterval(e.check);
								}

								if (self.client) {
									e.popup.close();

									self.$emit('feedback', {
										'type': 'success',
										'message': 'You are now logged in'
									});

									// relocate to quote page
									self.loginRedirect();
								}
							}
						}
					})
					.catch(error => {

					});
			}
		},
		loginRedirect() {
			const self = this;

			// Ensure Quote is assigned to Client
			axios.post('quote/assignClient')
				.then((resp) => {
					if (resp.data) {
						if (resp.data.success) {
							self.$router.go();
							// window.location.href = self.baseUrl+'/quote/contact';
						}
					}
				})
				.catch(error => {
				});
		},

		handleChangeType(type) {
			this.type = type;
		},
	}
}
</script>
<style scoped>
	.tooltip-el{
		@apply w-6;
	}
</style>